import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { AppService, DomainDataService } from '../../../../../services';
import { PersonDialog } from '../../../person-dialog';
import { EngagementViewerDialogService } from '../engagement-viewer.service';

@Component({
	selector: 'engagement-viewer-overview-part',
	standalone: true,
	templateUrl: './overview.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './overview.part.scss'
})
export class EngagementViewerOverviewPart {

	private readonly app = inject(AppService)
	private readonly domainData = inject(DomainDataService);
	private readonly service = inject(EngagementViewerDialogService);
	private readonly util = inject(UtilityService);
	private readonly dialog = inject(DialogService);

	public readonly engagementDetails = computed(() => {
		const details = this.service.engagementDetails();
		if (!details) return undefined;
		return {
			...details,
			lastContactUTC: this.util.date.formatUTC(details.lastContactUTC!, 'MM/DD/YYYY', 'No Time', 'en-US'),
			engagementDateUTC: this.util.date.formatUTC(details.engagementDateUTC, 'MM/DD/YYYY', 'No Time', 'en-US'),
			engaged: details.activity ? 'Awaiting Response' : 'Engaged',
			externalRoleName: this.domainData.data().engagementExternalRolesMap[details.externalRoleId]?.name,
			staffRoleName: this.domainData.data().staffRolesMap[details.staffRoleId]?.name,
			lastContactedByStaffName: this.app.getStaffNameById(details.lastContactStaffId),
			purposeDesc: this.domainData.data().engagementPurposesMap[details.purposeId]?.name
		}
	});

	public openPersonDialog(personId: number) {
		this.dialog.showCustom(PersonDialog, { data: { personId, toEdit: false } }, 800, 800)
	}

}